import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-ink-950 py-20" aria-labelledby="faq-title" data-id="element-64" data-mp="1bmlnvb30w3m2">
      <div className="mx-auto max-w-3xl px-5" data-id="element-65" data-mp="1gk58qtu87emz">
        <h2 id="faq-title" className="text-center font-display text-3xl uppercase text-cream sm:text-4xl" data-id="element-66" data-mp="249g4ty0mskus">
          Lo que más nos preguntan
        </h2>

        <ul className="mt-12 flex flex-col gap-3" data-id="element-67" data-mp="1ujef71smqudr">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <li key={faq.q} className="overflow-hidden rounded-2xl border border-cream/10 bg-ink-800" data-id="element-68" data-mp="1zh6fok7cbotk" data-mpi={i}>
                <h3 data-id="element-69" data-mp="2n6hbrodqwv1d">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors duration-150 hover:bg-cream/[0.03] focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-gold-500 sm:px-6" data-id="element-70" data-mp="2n5z6615714gs">
                    <span className="text-sm font-semibold text-cream sm:text-base" data-id="element-71" data-mp="1oj9l147k7w5o">{faq.q}</span>
                    <PlusIcon className={`h-5 w-5 shrink-0 text-gold-500 transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-72" data-mp="1jk6rafx15cd0" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-73" data-mp="1slo49pf54xxh">
                  {isOpen ? <motion.div id={`faq-panel-${i}`} key="panel" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.28,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-74" data-mp="36q2a1pf3aua">
                      <p className="px-5 pb-5 text-sm leading-relaxed text-cream/70 sm:px-6" data-id="element-75" data-mp="289dmne1fezef">
                        {faq.a}
                      </p>
                    </motion.div> : null}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}